import styled from "styled-components";
import theme from "../../../../styles/theme";

export const StyledInput = styled.input`
  width: 100%;
  padding: 12px 14px;
  border: 1px solid #5F6368;
  border-radius: 8px;
  background-color: #ffffff;
  color: #111827;
  font-family: ${theme.fonts.gilroyRegular};
  font-size: 14px;
  line-height: 20px;
  outline: none;
  transition: border-color 0.2s ease, box-shadow 0.2s ease,
    background-color 0.2s ease;

  &::placeholder {
    color: #9ca3af;
  }

  &:hover {
    border-color: #5f6368;
  }

  &:focus {
    border-color: #4285f4;
    box-shadow: 0 0 0 3px rgba(66, 133, 244, 0.2);
  }

`;
